"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.now = exports.performance = exports.nativeGlobalThis = exports.polyfill = void 0;
var Entry = /** @class */ (function () {
    function Entry(props) {
        this.props = props;
        this.name = this.props.name;
        this.entryType = this.props.entryType;
        this.startTime = this.props.startTime;
        this.duration = this.props.duration;
    }
    Entry.prototype.toJSON = function () {
        return this.props;
    };
    return Entry;
}());
var dateNow = Date.now || (function () { return Date.now(); });
var startOffset = dateNow();
var Exception = typeof DOMException !== 'undefined' ? DOMException : Error;
function polyfill(global) {
    var performance = (global['performance'] || {});
    var _entries = [];
    var _marksIndex = {};
    function _filterEntries(key, value) {
        var n = _entries.length;
        var result = [];
        var i = 0;
        for (; i < n; i++) {
            if (_entries[i][key] == value) {
                result.push(_entries[i]);
            }
        }
        return result;
    }
    function _clearEntries(type, name) {
        var i = _entries.length;
        while (i--) {
            var entry = _entries[i];
            if (entry.entryType == type && (name === void 0 || entry.name == name)) {
                _entries.splice(i, 1);
            }
        }
    }
    function isNotSupport(perf, method) {
        return !perf[method];
    }
    if (isNotSupport(performance, 'now')) {
        performance.now = performance.webkitNow || performance.mozNow || performance.msNow || function now() {
            return dateNow() - startOffset;
        };
    }
    if (isNotSupport(performance, 'mark') || isNotSupport(performance, 'measure')) {
        // mark
        performance.mark = performance.webkitMark || function mark(name) {
            var mark = new Entry({
                name: name,
                entryType: 'mark',
                startTime: performance.now(),
                duration: 0,
            });
            _entries.push(mark);
            _marksIndex[name] = mark;
        };
        // measure
        performance.measure = performance.webkitMeasure || function measure(name, startMark, endMark) {
            var argLen = arguments.length;
            var errMark;
            if (name == null) {
                throw new TypeError("Failed to execute 'measure' on 'Performance': 1 argument required, but only 0 present.");
            }
            else if (_marksIndex[startMark] == null) {
                errMark = startMark;
            }
            else if (_marksIndex[endMark] == null) {
                errMark = endMark;
            }
            if (errMark) {
                throw new Exception("Failed to execute 'measure' on 'Performance': The mark '" + errMark + "' does not exist.");
            }
            var start = argLen > 1 ? _marksIndex[startMark].startTime : performance.now();
            var end = argLen > 2 ? _marksIndex[endMark].startTime : performance.now();
            var entry = new Entry({
                name: name,
                entryType: 'measure',
                startTime: start,
                duration: end - start,
            });
            _entries.push(entry);
            return entry;
        };
        // getEntries
        performance.getEntries = performance.webkitGetEntries || function getEntries(filter) {
            if (filter != null) {
                return _entries.filter(function (entry) { return entry.name === filter.name && entry.entryType === filter.entryType; });
            }
            return _entries;
        };
        // getEntriesByType
        performance.getEntriesByType = performance.webkitGetEntriesByType || function getEntriesByType(type) {
            return _filterEntries('entryType', type);
        };
        // getEntriesByName
        performance.getEntriesByName = performance.webkitGetEntriesByName || function getEntriesByName(name) {
            return _filterEntries('name', name);
        };
        // clearMarks
        performance.clearMarks = performance.webkitClearMarks || function clearMarks(name) {
            _clearEntries('mark', name);
            delete _marksIndex[name];
        };
        // clearMeasures
        performance.clearMeasures = performance.webkitClearMeasures || function clearMeasures(name) {
            _clearEntries('measure', name);
        };
        // clearResourceTimings
        performance.clearResourceTimings = function clearResourceTimings() { };
    }
    try {
        if (!global['performance']) {
            // Polyfilling
            global['performance'] = performance;
        }
    }
    catch (_) { }
    return global;
}
exports.polyfill = polyfill;
exports.nativeGlobalThis = polyfill(0
    || typeof globalThis === 'object' && globalThis
    || typeof window === 'object' && window
    || typeof global === 'object' && global
    || {});
if (typeof self !== 'undefined' && self !== exports.nativeGlobalThis) {
    polyfill(self);
}
exports.performance = exports.nativeGlobalThis.performance;
exports.now = function () {
    return exports.performance.now();
};
//# sourceMappingURL=performance.js.map